import en from './en'
import bs from './bs'

export const languagesList = [
  {
    code: 'bs',
    shortName: 'Bos',
    name: 'Bosanski'
  },
  {
    code: 'en',
    shortName: 'Eng',
    name: 'English'
  }
]

export const translations = {
  en, bs
}

const bosnianPluralization = (number, choicesLength) => {
  let option = null
  if (number === 0) {
    option = 0
  }
  if (number === 1) {
    option = 1
  }
  if (number >= 2 && number <= 4) {
    option = 2
  }
  if (number > 4) {
    option = 3
  }
  return option > choicesLength ? choicesLength : option
}

export const pluralizationRules = {
  bs: bosnianPluralization
}
